import { type FC, type PropsWithChildren, memo } from 'react';

const PureChildren: FC<PropsWithChildren> = memo(({ children }) => <>{children}</>);

PureChildren.displayName = 'PureChildren';

export { PureChildren };
